import React from 'react';
import {
  Paper,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';
import { Student, RiskFactor } from '../../../types';
import { mockStudentData } from '@/data/mockStudents';

const mockStudentsAtRisk: (Student & { primaryRisk: RiskFactor })[] = [
  {
    ...mockStudentData,
    id: '1',
    firstName: 'John',
    lastName: 'Doe',
    grade: 9,
    attendanceRate: 75,
    interventions: [],
    riskFactors: [],
    academicPerformance: { gpa: 1.8, credits: 20, coursesFailing: 2 },
    primaryRisk: {
      type: 'attendance',
      severity: 'high',
      dateIdentified: '2023-08-01',
      notes: 'Missed 25% of classes in the last month'
    }
  },
  // Add more mock data as needed
];

const getSeverityColor = (severity: string) => {
  switch (severity) {
    case 'high':
      return 'error';
    case 'medium':
      return 'warning';
    case 'low':
      return 'info';
    default:
      return 'default';
  }
};

export const RiskAnalysis: React.FC = () => {
  return (
    <Paper sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <WarningIcon color="warning" sx={{ mr: 1 }} />
        <Typography variant="h6">Students at Risk</Typography>
      </Box>

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Student</TableCell>
              <TableCell>Grade</TableCell>
              <TableCell>Risk Type</TableCell>
              <TableCell>Severity</TableCell>
              <TableCell>Attendance</TableCell>
              <TableCell>GPA</TableCell>
              <TableCell>Failing Courses</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {mockStudentsAtRisk.map((student) => (
              <TableRow key={student.id}>
                <TableCell>{`${student.firstName} ${student.lastName}`}</TableCell>
                <TableCell>{student.grade}</TableCell>
                <TableCell>
                  <Chip
                    label={student.primaryRisk.type}
                    size="small"
                  />
                </TableCell>
                <TableCell>
                  <Chip
                    label={student.primaryRisk.severity}
                    color={getSeverityColor(student.primaryRisk.severity)}
                    size="small"
                  />
                </TableCell>
                <TableCell>{`${student.attendanceRate}%`}</TableCell>
                <TableCell>{student.academicPerformance.gpa}</TableCell>
                <TableCell>{student.academicPerformance.coursesFailing}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};